(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    var init = function () {
      var carousels = document.querySelectorAll('[data-carousel]');
      if (!carousels.length) return;

      // Une vidéo/animation en autoplay doit respecter prefers-reduced-motion (WCAG 2.2.2).
      var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) return;

      carousels.forEach(function (car, idx) {
        var slides = car.querySelectorAll('.pcard__slide');
        var dots = car.querySelectorAll('.pcard__dot');
        if (slides.length < 2) return;

        var interval = parseInt(car.getAttribute('data-interval'), 10) || 3500;
        var i = 0;
        var advance = function () {
          slides[i].classList.remove('is-active');
          if (dots[i]) dots[i].classList.remove('is-active');
          i = (i + 1) % slides.length;
          slides[i].classList.add('is-active');
          if (dots[i]) dots[i].classList.add('is-active');
        };

        // Léger décalage entre les cartes → défilement plus organique.
        window.setTimeout(function () {
          window.setInterval(advance, interval);
        }, idx * 1200);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section-media"] && !Shopify.designMode) return;
  try {
    (function () {
    var motionOk = !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
    var landscape = window.matchMedia ? matchMedia('(min-aspect-ratio: 1/1)') : null;

    // prefers-reduced-motion : une vidéo autoplay est une animation (WCAG 2.2.2) → on la fige.
    if (!motionOk) {
      document.querySelectorAll('.smedia__media').forEach(function (v) {
        if (v.tagName === 'VIDEO') {
          v.removeAttribute('autoplay');
          v.pause();
        }
      });
    }

    // Bascule vers la vidéo paysage dédiée quand l'écran est en paysage.
    document.querySelectorAll('.smedia--has-desktop').forEach(function (el) {
      var fit = el.querySelector('.smedia__media--fit');
      var land = el.querySelector('.smedia__media--landscape');

      function apply() {
        var useLand = land && landscape && landscape.matches;
        el.classList.toggle('smedia--show-desktop', !!useLand);
        if (!motionOk) {
          return;
        }
        if (useLand) {
          if (fit && fit.tagName === 'VIDEO') { fit.pause(); }
          if (land.preload === 'none') { land.preload = 'auto'; land.load(); }
          land.play().catch(function () {});
        } else {
          if (land) { land.pause(); }
          if (fit && fit.tagName === 'VIDEO') { fit.play().catch(function () {}); }
        }
      }

      apply();
      if (landscape) {
        if (landscape.addEventListener) {
          landscape.addEventListener('change', apply);
        } else if (landscape.addListener) {
          landscape.addListener(apply);
        }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
